import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#202450',
        secondary: '#2C8FBF',
        tertiary: '#e1e1e1',
        accent: '#cedc00',
        error: '#b71c1c',
      }
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
